<template>
  <div class="numpad">
    <div v-for="key in keyList" :key="key.k" class="np-key" role="button"
         :class="[key.cls, { 'np-disabled': key.disabled }]"
         :style="key.style" @click="press(key)">
      <template v-if="key.k === 'ok'">
        <span v-for="(ch, i) in key.label.split('')" :key="i" class="np-confirm-ch">{{ ch }}</span>
      </template>
      <span v-else-if="key.label">{{ key.label }}</span>
    </div>
  </div>
</template>

<script>
/**
 * 云贝式触屏数字键盘（cashier-touch-v2 Task4，所有金额/数量/手机号弹窗复用）：
 * 4列布局——
 *   [1] [2] [3] [清空]
 *   [4] [5] [6] [确认]   ← 确认第4列纵向跨第2-4行，蓝色渐变底白字
 *   [7] [8] [9] [确认]
 *   [ .  占2格 ][0][确认]
 * 按键高≥64px 触控友好；数字键白底深灰字、清空白底黑字。
 * v-model 模式：value 累加字符后 emit('input', 新值)；清空键置''；确认 emit('confirm')。
 * dot=false 时小数点键禁用（手机号等整数输入场景，布局不变）。
 */
export default {
  name: 'NumPad',
  props: {
    value: { type: [String, Number], default: '' },
    dot: { type: Boolean, default: true },
    confirmText: { type: String, default: '确认' }
  },
  computed: {
    keyList() {
      const confirmStyle = { gridRow: '2 / span 3', gridColumn: '4' }
      const dotStyle = { gridColumn: 'span 2' }
      return [
        { k: '1', label: '1', char: '1' },
        { k: '2', label: '2', char: '2' },
        { k: '3', label: '3', char: '3' },
        { k: 'clear', label: '清空', cls: 'np-clear', char: '' },
        { k: '4', label: '4', char: '4' },
        { k: '5', label: '5', char: '5' },
        { k: '6', label: '6', char: '6' },
        { k: 'ok', label: this.confirmText, cls: 'np-confirm', style: confirmStyle, char: '' },
        { k: '7', label: '7', char: '7' },
        { k: '8', label: '8', char: '8' },
        { k: '9', label: '9', char: '9' },
        { k: 'dot', label: '.', cls: 'np-dot', style: dotStyle, char: '.', disabled: !this.dot },
        { k: '0', label: '0', char: '0' }
      ]
    }
  },
  methods: {
    press(key) {
      if (key.disabled) return
      if (key.k === 'clear') {
        this.$emit('input', '')
        this.$emit('clear')
        return
      }
      if (key.k === 'ok') {
        this.$emit('confirm', String(this.value || ''))
        return
      }
      if (key.k === 'dot') {
        const v = String(this.value || '')
        if (v.indexOf('.') >= 0) return // 已有小数点不重复追加
        this.$emit('input', (v === '' ? '0.' : v + '.'))
        return
      }
      this.$emit('input', String(this.value || '') + key.char)
    }
  }
}
</script>

<style scoped>
.numpad {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: 64px;
  gap: 10px;
  user-select: none;
}
.np-key {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  font-size: 24px;
  font-weight: 500;
  color: #303133;
  cursor: pointer;
  transition: background 0.1s;
}
.np-key:active {
  background: #ecf5ff;
  border-color: #b3d8ff;
}
.np-clear {
  font-size: 20px;
  color: #1f2d3d;
}
.np-confirm {
  background: linear-gradient(180deg, #54a0ff 0%, #1e78e8 100%);
  border: none;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  flex-direction: column;
  gap: 12px;
}
.np-confirm-ch {
  line-height: 1;
}
.np-confirm:active {
  background: linear-gradient(180deg, #3f92f5 0%, #1668cc 100%);
}
.np-disabled {
  background: #f5f7fa;
  color: #c0c4cc;
  cursor: not-allowed;
}
</style>
